import { render, staticRenderFns } from "./MarkPage.vue?vue&type=template&id=b6232452&scoped=true&"
import script from "./MarkPage.vue?vue&type=script&lang=js&"
export * from "./MarkPage.vue?vue&type=script&lang=js&"
import style0 from "./MarkPage.vue?vue&type=style&index=0&id=b6232452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6232452",
  null
  
)

export default component.exports